<template>
  <v-container fluid />
</template>

<script>
export default {
  name: "Main",
  created() {
    const mod = this.$store.getters["modules/selectedModule"];
    if (mod?.uuid) {
      window.location.replace(`/app/modules/${mod.uuid}/lessons`);
    } else {
      window.location.replace("/app/modules");
    }
  },
};
</script>
